import { analytics } from "../utils/init-firebase";
import { logEvent } from "firebase/analytics";

export const useAnalytics = () => {
  /**
   * Logs a custom event to Google Analytics.
   * @param {string} eventName - The name of the event to log.
   * @param {object} [eventParams] - Optional parameters to associate with the event.
   */
  const logAnalyticsEvent = (eventName, eventParams) => {
    if (!eventName) {
      console.error("Analytics Error: eventName is required.");
      return;
    }
    if (!analytics) return; // analytics unavailable in this browser — no-op
    try {
      logEvent(analytics, eventName, eventParams);
    } catch (error) {
      console.error("Error logging analytics event:", error);
    }
  };

  return { logAnalyticsEvent };
};